import {css, html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/Button/Button'
import '@isceco/widget-library2/basic-elements/List/List'
import '@isceco/widget-library2/basic-elements/Title/Title'
import '@isceco/widget-library2/basic-elements/Spinner/Spinner'
import '@isceco/widget-library2/basic-elements/Popup/Popup'
import ListService from '@isceco/widget-library2/basic-elements/List/ListService.js';
import WebComponent from '../../../WebComponent.js'
import MonitoringColumns from "./MonitoringColumns";
import RowVariant from "./RowVariant";
import MonitoringService from "../../../services/MonitoringService";
import SchedulerService from "../../../services/SchedulerService";
import I18n from "../../../i18n";
import AuthorizationFilter from "../../Authorization/AuthorizationFilter";

export default class Monitoring extends WebComponent {

  static IDENTIFIER = 'admin-monitoring';
  static LIST_ID = this.IDENTIFIER + '-list';

  static get EVENT_KEYS() {
    return {
      RELOAD_TRIGGERED: 'admin-monitoring-reload-triggered',
      IMPORT_DONE: 'admin-monitoring-import-done'
    }
  }

  constructor() {
    super()
    this.monitoringService = new MonitoringService();
    this.schedulerService = new SchedulerService();
    this.columns = [];
  }

  get css() {
    return css`
      isceco-title:first-of-type {
        display: block;
        margin-top: -20px;
      }
    `
  }

  get translationFile() {
    return './views/Admin/Monitoring/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this._refresh = () => {
      this.loadData();
      send(Monitoring.EVENT_KEYS.RELOAD_TRIGGERED);
    };

    this.columns = [
      MonitoringColumns.FILE_TYPE_COLUMN(),
      MonitoringColumns.LAST_FILE_DATE_COLUMN(this.i18n),
      MonitoringColumns.ERROR_MESSAGE_COLUMN(),
      MonitoringColumns.LAST_VALID_FILE_DATE_COLUMN()
    ]

    document.addEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this._refresh);
    document.addEventListener(Monitoring.EVENT_KEYS.IMPORT_DONE, this._refresh);

    this.monitoringService.getBackendListUrl()
      .then(url => {
        this.url = url;
        this.loadData();
      })
      .catch(_ => {
        this.render();
      })
  }

  disconnectedCallback() {
    document.removeEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this._refresh);
    document.removeEventListener(Monitoring.EVENT_KEYS.RELOAD_TRIGGERED, this._refresh);
  }

  loadData() {
    this.monitoringService.getLastSchedulerRun()
      .then(lastRun => {
        this.lastRun = lastRun;
        this.render();
      })
      .catch(_ => {
        this.render();
      })
  }

  getTemplate() {
    return html`
      <isceco-title id="page-title"
                    text="${this.i18n.translate('admin.monitoring.title')}"
                    help-text="${this.i18n.translate('admin.monitoring.title.info')}"
                    size="large">
        <div style="display: flex;">
          <isceco-popup direction="left" style="top: 13px">
            <i slot="wrapper" class="icon info circle" style="font-size: 16px !important"></i>
            <div slot="content">
              ${this.i18n.translate('admin.monitoring.lastRun.info')}
            </div>
          </isceco-popup>
          <p style="margin-bottom: 10px">
            ${this.i18n.translate('admin.monitoring.lastRun')}:
            <b>${formatDateTime(this.lastRun)}</b></p>
        </div>
      </isceco-title>

      <isceco-list
        id="${Monitoring.LIST_ID}"
        pagination="off"
        .i18n="${this.i18n}"
        .columns="${this.columns}"
        .listService="${new ListService(this.url.concat('/').concat('fileStatusDetail'))}"
        .rowVariant="${new RowVariant()}"
        update-event="${Monitoring.EVENT_KEYS.RELOAD_TRIGGERED}"
      >
      </isceco-list>
      <isceco-spinner hidden
                      modal
                      size="large"
                      id="modal-spinner"
      ></isceco-spinner>
      ${this.renderButtons()}
    `
  }

  renderButtons() {
    if (AuthorizationFilter._hasRoleAdmin()) {
      return html`
        <div style="display: flex; padding-top: 20px">
          <isceco-button text=${this.i18n.translate('admin.monitoring.restartImport')}
                         icon="redo alternate"
                         variant="primary"
                         size="small"
                         @click=${_ => this.startImport()}
                         id="start-scheduler"
          ></isceco-button>
          <isceco-button text=${this.i18n.translate('admin.monitoring.goToFtp')}
                         icon="external"
                         variant="primary"
                         size="small"
                         @click=${_ => window.open(constructURL({'to': '#Sftp', 'id': ''}), "_blank")}
                         id="go-to-ftp"
                         style="padding-left: 10px"
          ></isceco-button>
        </div>
      `
    } else {
      return html``
    }
  }

  startImport() {
    document.querySelector('#modal-spinner')
      .show(
        this.schedulerService.restartScheduler()
          .then(_ => {
            showAlert(this.i18n.translate('admin.monitoring.restartImport.success'), '', 'success')
            send(Monitoring.EVENT_KEYS.IMPORT_DONE)
          })
          .catch(_ => {
            showAlert(this.i18n.translate('admin.monitoring.restartImport.error'), '', 'error')
          })
      )
  }
}
customElements.define('gasmonitoring-frontend-admin-monitoring', Monitoring)
